import React from "react";
import Password from "react-password-strength";
import "react-password-strength/dist/style.css";
import "./PasswordStrength.css";

const passwordStrength = (props) => (
  <Password
    style={{
      border: "none",
      backgroundSize: "0 2px, 100% 1px",
      fontSize: "1rem",
      lineHeight: "1.57142857",
      ...props.style,
    }}
    minLength={5}
    minScore={2}
    tooShortWord="Short"
    scoreWords={["Poor", "Weak", "Good", "Strong", "Excellent"]}
    changeCallback={(state) =>
      props.userPasswordChangeHandler(state.password, state.isValid)
    }
    inputProps={{
      name: "password",
      autoComplete: "off",
      className: "form-control empty",
      ...props.inputProps,
    }}
  />
);

export default passwordStrength;
